import { useDashboardScope } from '../context/DashboardHostContext';

/** Project/site ids for PermissionDecorator calls inside dashboard widgets. */
export function useDashboardPermissionScope(): {
  readonly project_id: number | undefined;
  readonly site_id: number | undefined;
} {
  const { project_id, site_id } = useDashboardScope();

  return {
    project_id: project_id ?? undefined,
    site_id: site_id ?? undefined,
  };
}
